import { jsx as _jsx } from "react/jsx-runtime";
import { CloseableInformationBanner } from '@common/information-banner/closeable-infomation-banner';
import { IdpBannerDefaultContent } from './idp-banner-default-content';
export function AddUsersIDPBanner({ children, bannerKey }) {
    return (_jsx(CloseableInformationBanner, { variant: "neutral", bannerKey: bannerKey, children: _jsx(IdpBannerDefaultContent, { children: children }) }));
}
